import '../styles/popular-makes.css';
import { carMakes, bodyTypes, zambianCities } from '../data/zambianCars';

// SEO-focused, fully crawlable section listing the car brands, popular models,
// body types and Zambian cities ZamWheelz covers. Anchored content like this
// helps the site rank for "Toyota for sale in Lusaka", "Nissan Note Zambia", etc.
const PopularMakesSection = () => {
  return (
    <section className="popular-makes popular-makes--seo-hidden" id="brands" aria-labelledby="brands-heading">
      <div className="container">
        <span className="section-tag animate-on-scroll">🚘 Browse by Brand</span>
        <h2 className="section-title animate-on-scroll" id="brands-heading">
          Cars for Sale in Zambia by Brand
        </h2>
        <p className="section-desc animate-on-scroll">
          From fuel-efficient Toyota Vitz and Nissan Note hatchbacks to rugged
          Toyota Hilux and Mitsubishi Pajero 4x4s. Find every popular make and
          model on Zambia&#39;s roads, listed by verified sellers and dealers in
          Lusaka, Kitwe, Ndola, Livingstone and across the country.
        </p>

        <div className="makes-grid stagger-children">
          {carMakes.map((make) => (
            <div className="make-card animate-on-scroll" key={make.name}>
              <h3 className="make-name">{make.name}</h3>
              <ul className="make-models">
                {make.popular.slice(0, 8).map((model) => (
                  <li key={model}>
                    <a href="/#categories">{make.name} {model}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="seo-taxonomy">
          <div className="taxonomy-block animate-on-scroll">
            <h3>Shop by Vehicle Type</h3>
            <ul className="chip-list">
              {bodyTypes.map((type) => (
                <li key={type}><a href="/#categories">{type} in Zambia</a></li>
              ))}
            </ul>
          </div>

          <div className="taxonomy-block animate-on-scroll">
            <h3>Find Vehicles in Your City</h3>
            <ul className="chip-list">
              {zambianCities.map((city) => (
                <li key={city}><a href="/#categories">Cars for sale in {city}</a></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PopularMakesSection;
